import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const DEFAULT_OPTIONS = [["this", "Just this task"], ["future", "This and all future tasks"], ["all", "All tasks in the series"]];

export function RecurringScopeDialog({ open, onOpenChange, title = "Recurring task", description, danger = false, busy = false, onPick, options = DEFAULT_OPTIONS }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm" data-testid="recurring-scope-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description || "This task repeats. Choose which tasks to apply this to:"}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          {options.map(([k, l]) => <Button key={k} variant="outline" disabled={busy} data-testid={`scope-${k}`} onClick={() => onPick(k)}>{l}</Button>)}
        </div>
        <DialogFooter>
          <Button variant="ghost" disabled={busy} onClick={() => onOpenChange(false)}>Cancel</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
